module.exports = __webpack_public_path__ + "static/media/tutoring-recorder.7f6a4e64.png";